module.exports = __webpack_public_path__ + "static/img/money-bag.11fe717.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/detailed/money-bag.svg
// module id = 9bx5
// module chunks = 0